"use client";

import Image from "next/image";
import { useRef } from "react";
import "swiper/css";
import "swiper/css/navigation";
import type { SolutionPageContent } from "@/app/servicos/modernizacao-de-sistemas-legados/content/content";
import { useServiceCardsAnimation } from "../services-pages/use-service-cards-animation";

type ServicePageTemplateProps = {
	solutions: SolutionPageContent;
};

export default function IAFlowSolutionsSection({
	solutions,
}: ServicePageTemplateProps) {
	const sectionRef = useRef<HTMLElement | null>(null);

	useServiceCardsAnimation(sectionRef, {
		preset: "tilt",
	});

	return (
		<section
			ref={sectionRef}
			className="md:container-padding relative border-y border-gray-300"
		>
			<div
				data-service-cards-animation-trigger
				className="container relative md:border-x md:border-gray-300 px-6 lg:px-18 3xl:px-24! py-32"
			>
				<span className="hidden md:inline-flex absolute -top-1.75 -left-1.75 h-3 w-3 border border-gray-300 bg-gray-1000" />
				<span className="hidden md:inline-flex absolute -top-1.75 -right-1.75 h-3 w-3 border border-gray-300 bg-gray-1000" />

				<div className="max-w-148 mx-auto text-center flex flex-col gap-11 items-center">
					<div data-service-card className="flex flex-col gap-11 items-center">
						<Image
							data-service-card-media
							src={solutions.ia_flow?.image || ""}
							alt={solutions.ia_flow?.title || ""}
							aria-hidden="true"
							className="w-full max-w-45.5"
							width={1000}
							height={1000}
						/>
						<h2 className="title">{solutions.ia_flow?.title}</h2>
					</div>
				</div>
			</div>
		</section>
	);
}
